import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DefaultButton } from "../../components/micro";
import CustomTable from "../../components/customtable/CustomTable";
import { getSingleUser } from "../../redux/user/slice";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import Tab from "../../components/common/Tab";
import Papa from "papaparse";

const ViewUser = () => {
  const navigate = useNavigate();
  const [habitLimit, setHabitLimit] = useState(10);
  const [habitPage, setHabitPage] = useState(1);
  const [openAccordion, setOpenAccordion] = useState([]);
  const [activeTab, setActiveTab] = useState("User Habits");
  const { id } = useParams();
  const dispatch = useDispatch();

  const { userData, isLoading } = useSelector((store) => ({
    userData: store?.usersData?.getSingleUserStatus?.data?.data,
    isLoading: store?.usersData?.loading,
  }));
  useEffect(() => {
    if (userData?.onboardingData?.length) {
      setOpenAccordion(userData.onboardingData.map((h) => h._id)); // open all
    }
  }, [userData]);

  useEffect(() => {
    if (!id) return;
    dispatch(getSingleUser({ id, habitLimit, habitPage }));
  }, [dispatch, id, habitLimit, habitPage]);

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Name
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Icon
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Time
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Reminder
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Repeat
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Status
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Skipped
      </th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(userData?.habits || []).map((h, index) => (
        <tr
          key={h?._id || index}
          className="border-t border-borderTheme/80 hover:bg-navTheme/5"
        >
          <td className="px-5 py-3 truncate" title={h?.name || "-"}>
            {h?.name || "-"}
          </td>
          <td className="px-5 py-3">{h?.icon || "-"}</td>
          <td className="px-5 py-3">{h?.time || "-"}</td>
          <td className="px-5 py-3">{h?.reminderEnabled ? "True" : "False"}</td>
          <td className="px-5 py-3">
            {h?.repeat ? h.repeat.replace(/_/g, " ").toUpperCase() : "-"}
          </td>
          <td className="px-5 py-3 capitalize">
            {h?.status === "submit"
              ? "Submitted"
              : h?.status === "cancelled"
              ? "Cancelled"
              : h?.status === "complete"
              ? "Completed"
              : "Incompleted"}
          </td>
          <td className="px-5 py-3">{h?.skip?.isSkipped ? "True" : "False"}</td>
        </tr>
      ))}
    </>
  );
  // Table Headers
  const OnboardingHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Question
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Answer
      </th>
      <th className="p-2 w-40 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Completed
      </th>
      <th className="p-2 w-40 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Status
      </th>
    </>
  );

  const OnboardingRows = () => (
    <>
      {userData?.onboardingData && userData.onboardingData.length > 0 ? (
        userData.onboardingData.map((h, index) => (
          <tr
            key={h?._id || index}
            className="border-t border-borderTheme/80 hover:bg-lightgreen/40"
          >
            <td className="px-5 py-3">{h?.question || "-"}</td>
            <td className="px-5 py-3">
              {Array.isArray(h?.answer) && h.answer.length > 0 ? (
                <div className="border rounded-lg">
                  <button
                    type="button"
                    className="w-full flex justify-between items-center px-3 py-2 text-left font-medium text-gray-800 bg-background_grey hover:bg-background_grey/20 rounded-t-lg"
                    onClick={() =>
                      setOpenAccordion((prev) =>
                        prev.includes(h._id)
                          ? prev.filter((id) => id !== h._id)
                          : [...prev, h._id]
                      )
                    }
                  >
                    Answers
                    <span className="text-gray-600">
                      {openAccordion.includes(h._id) ? "−" : "+"}
                    </span>
                  </button>
                  {openAccordion.includes(h._id) && (
                    <div className="px-4 py-2 bg-white rounded-lg">
                      <ul className="list-disc pl-4">
                        {h.answer.map((ans, i) => (
                          <li key={i} className="text-sm text-gray-700">
                            {ans}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ) : (
                "-"
              )}
            </td>

            <td className="px-5 py-3">
              {h?.iscompleted === true ? "Completed" : "Incomplete"}
            </td>
            <td className="px-5 py-3">
              {h?.status === "submit" ? "Submited" : "Skip"}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td className="px-5 py-3" colSpan={4} align="center">
            -
          </td>
        </tr>
      )}
    </>
  );
  const handleExportCSV = () => {
    if (!userData) return;

    // 1️ Common user info
    const userInfo = [
      { Label: "First Name", Value: userData?.firstName || "-" },
      { Label: "Last Name", Value: userData?.lastName || "-" },
      { Label: "Email", Value: userData?.email || "-" },
      { Label: "Admin", Value: userData?.isAdmin ? "True" : "False" },
      {
        Label: "Answer Given",
        Value: userData?.isAnswergiven ? "True" : "False",
      },
      { Label: "Streak Count", Value: userData?.streakCount || 0 },
    ];

    let dataToExport = [];
    let fileLabel = "";

    // 2️ Export based on tab
    if (activeTab === "User Habits") {
      dataToExport = (userData?.habits || []).map((h, i) => ({
        "Sr No": i + 1,
        Name: h?.name || "-",
        Icon: h?.icon || "-",
        Time: h?.time || "-",
        Reminder: h?.reminderEnabled ? "True" : "False",
        Repeat: h?.repeat ? h.repeat.replace(/_/g, " ").toUpperCase() : "-",
        Status:
          h?.status === "submit"
            ? "Submitted"
            : h?.status === "cancelled"
            ? "Cancelled"
            : h?.status === "complete"
            ? "Completed"
            : "Incomplete",
        Skipped: h?.skip?.isSkipped ? "True" : "False",
      }));
      fileLabel = "HabitData";
    } else if (activeTab === "Onboarding Data") {
      dataToExport = (userData?.onboardingData || []).map((h, i) => ({
        "Sr No": i + 1,
        Question: h?.question || "-",
        Answer: Array.isArray(h?.answer)
          ? h.answer.join(", ")
          : h?.answer || "-",
        Completed: h?.iscompleted ? "Completed" : "Incomplete",
        Status: h?.status === "submit" ? "Submitted" : "Skipped",
      }));
      fileLabel = "OnboardingData";
    }

    // 3️ Convert both to CSV and combine
    const userInfoCSV = Papa.unparse(userInfo);
    const dataCSV = Papa.unparse(dataToExport);
    const combinedCSV = `${userInfoCSV}\n\n${dataCSV}`;

    // 4️ Download CSV
    const blob = new Blob([combinedCSV], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${fileLabel}_${userData?.firstName || "data"}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const tabs = [
    {
      label: "User Habits",
      content: (
        <div className="w-full bg-white shadow rounded-lg mt-4">
          <CustomTable
            overflowVisibleLg={true}
            columnHeaders={<ColumnHeaders />}
            dataRows={<DataRows />}
            data={{
              data: userData?.habits || [],
              pagination: userData?.pagination || {},
            }}
            loading={isLoading}
            showPagination={true}
            disableNext={!!userData?.data?.length}
            disablePrev={!!userData?.data?.length}
            setPaginationCurrentLimit={setHabitLimit}
            paginationCurrentLimit={habitLimit}
            current={userData?.pagination?.page || habitPage}
            total={userData?.pagination?.total || 0}
            paginationData={(crPage) => setHabitPage(crPage)}
            lastPage={Math.ceil(
              (userData?.pagination?.total || 0) / habitLimit
            )}
          />
        </div>
      ),
    },
    {
      label: "Onboarding Data",
      content: (
        <div className="w-full bg-white shadow rounded-lg mt-4">
          <CustomTable
            overflowVisibleLg
            columnHeaders={<OnboardingHeaders />}
            dataRows={<OnboardingRows />}
            data={{ data: userData?.onboardingData || [] }}
            loading={isLoading}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="space-y-5">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            View User
          </h6>
        </div>
        <Breadcrumb
          breadCrumbParent={"User"}
          // breadCrumbParent2={"User"}
          breadCrumbActive={"View User"}
          breadCrumbTitleKey={"/"}
          classes=""
        />
        {/* view list */}
        {isLoading ? (
          <RippleLoader />
        ) : (
          <div className="">
            <div>
              <div className="bg-white shadow-md rounded-lg p-6">
                <h6 className="my-2 text-lg font-medium">User Information:</h6>
                <div className="grid grid-cols-2">
                  <div className="flex gap-2">
                    <p className="font-medium">User Name: </p>
                    <p>{userData?.firstName}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-medium">Last Name: </p>
                    <p>{userData?.lastName}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-medium">Email: </p>
                    <p>{userData?.email}</p>
                  </div>

                  <div className="flex gap-2">
                    <p className="font-medium">Admin: </p>
                    <p>{userData?.isAdmin ? "True" : "False"}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-medium">Answer Given: </p>
                    <p>{userData?.isAnswergiven ? "True" : "False"}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-medium">Streak Count: </p>
                    <p>{userData?.streakCount}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-medium">Habits Count: </p>
                    <p>{userData?.habits?.length || 0}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-medium">Onboarding Questions Count: </p>
                    <p>{userData?.onboardingData?.length || 0}</p>
                  </div>
                </div>

                <div className="mt-4 flex justify-end">
                  <button
                    className="bg-themeBtn text-white flex items-center justify-center px-4 py-3 rounded"
                    type="button"
                    onClick={handleExportCSV}
                  >
                    + Export {activeTab}
                  </button>
                </div>

                <div className="col-span-2 mt-4">
                  {/*  Tabs Section */}
                  <Tab
                    tabs={tabs}
                    btnDivClass="border border-themeBtn"
                    defaultActiveLabel="User Habits"
                    onTabChange={(label) => setActiveTab(label)}
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <DefaultButton
                  type="button"
                  value={"edit"}
                  onClick={() =>
                    navigate("/edit-user", {
                      state: {
                        user: userData,
                        mode: "viewedit",
                        viewmode: "viewedit",
                      },
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewUser;
